import { 
  STORE_USER, 
  USER_SIGNED_OUT, 
  USER_EXPIRED, 
  STORE_USER_ERROR, 
  LOADING_USER,
  LOGIN_SUCCESS,
  LOGIN_FAILURE
} from './types';
import { setAuthHeader } from '../utils/requestHeader';
  
export function storeUser(user) {
  setAuthHeader(user.access_token)
  return {
    type: STORE_USER,
    payload: user
  }
}

export function loadingUser() {
  return {
    type: LOADING_USER
  }
}

export function storeUserError() {
  return {
    type: STORE_USER_ERROR
  }
}

export function userExpired() {
  return {
    type: USER_EXPIRED
  }
}

export function userSignedOut() {
  return {
    type: USER_SIGNED_OUT
  }
}

export function loginSuccess(userData) {
  let user = userData?.user || userData;
  const provider = userData?.provider || 'unknown';
  
  if (provider === 'google' || provider === 'microsoft') {
    if (user.accessToken) {
      setAuthHeader(user.accessToken);
    } else if (user.idToken) {
      setAuthHeader(user.idToken);
    }
  } else if (provider === 'mylogin') {
    const accessToken = localStorage.getItem('mylogin_access_token');
    if (accessToken) {
      setAuthHeader(accessToken);
    }
  } else if (provider === 'email' || provider === 'qr') {
    // For email and QR, we might have token in the user object
    if (user.token) {
      setAuthHeader(user.token);
    }
  }
  
  // Make sure provider is stored with the user info
  if (!user.provider) {
    user = { ...user, provider };
  }
  
  // Store provider info in localStorage for recovery after page refresh
  localStorage.setItem('auth_provider', provider);
  
  return {
    type: LOGIN_SUCCESS,
    payload: { user, provider }
  };
}

export function loginFailure(error) {
  return {
    type: LOGIN_FAILURE,
    payload: error
  };
}

